import React from 'react'
import Card from '../../components/Card'

export default function () {
	return (
		<div className="flex flex-col text-slate-800 sm:mx-4 sm:my-6 md:mx-32 md:my-12 leading-loose">
			<Card className="flex flex-col">
				<h1 className="text-slate-800 mb-4">Termos de Uso – Positronic Tech</h1>

				<p>Bem-vindo à Positronic Tech! Estes Termos de Uso regulam o acesso e a utilização dos serviços, plataformas e conteúdos oferecidos por nossa empresa. Ao acessar ou utilizar nossos serviços, o usuário concorda com os termos aqui descritos. Caso não concorde, recomendamos que interrompa o uso imediatamente.</p>

				<p className="font-bold mt-4">1. Sobre os serviços</p>
				<p>A Positronic Tech oferece soluções digitais com foco em inovação, desempenho e segurança, incluindo plataformas online, softwares personalizados, consultorias e ferramentas de automação. Os serviços estão sujeitos a atualizações, modificações e melhorias contínuas.</p>

				<p className="font-bold mt-4">2. Aceitação dos termos</p>
				<p>O uso dos serviços implica na aceitação integral destes Termos de Uso. O usuário declara estar legalmente autorizado para utilizar os serviços da Positronic Tech, assumindo total responsabilidade pela veracidade das informações fornecidas.</p>

				<p className="font-bold mt-4">3. Cadastro e segurança</p>
				<p>Para acessar determinadas funcionalidades, o usuário pode ser solicitado a realizar um cadastro, fornecendo dados verdadeiros, atualizados e completos. É responsabilidade do usuário manter a confidencialidade de sua senha e informações de acesso.</p>

				<p>O usuário concorda em notificar imediatamente a Positronic Tech sobre qualquer uso não autorizado de sua conta ou qualquer outra violação de segurança.</p>

				<p className="font-bold mt-4">4. Uso permitido</p>
				<p>O usuário se compromete a utilizar os serviços da Positronic Tech apenas para fins lícitos e conforme as disposições destes Termos. É vedado:</p>

				<p>Utilizar os serviços para práticas ilegais ou fraudulentas;</p>
				<p>Violar direitos de propriedade intelectual ou confidencialidade de terceiros;</p>
				<p>Distribuir vírus, spam ou qualquer outro código malicioso;</p>
				<p>Praticar engenharia reversa, tentativa de invasão ou extração de dados sem consentimento.</p>

				<p className="font-bold mt-4">5. Propriedade intelectual</p>
				<p>Todo o conteúdo, marca, logotipo, interface, design, código e demais elementos disponibilizados pela Positronic Tech são protegidos por direitos autorais e de propriedade intelectual. É proibida a reprodução, distribuição ou modificação sem autorização expressa.</p>

				<p className="font-bold mt-4">6. Limitação de responsabilidade</p>
				<p>A Positronic Tech não se responsabiliza por danos diretos, indiretos, incidentais ou consequenciais decorrentes do uso ou da impossibilidade de uso dos serviços, incluindo falhas de acesso, erros técnicos, perda de dados ou conteúdo, exceto nos casos expressamente exigidos por lei.</p>

				<p className="font-bold mt-4">7. Modificações dos termos</p>
				<p>Estes Termos de Uso podem ser modificados a qualquer momento, sendo a versão atualizada publicada em nossos canais oficiais. Recomendamos a leitura periódica. O uso contínuo dos serviços após modificações será considerado como aceitação tácita.</p>

				<p className="font-bold mt-4">8. Política de Privacidade</p>
				<p>O tratamento de dados pessoais coletados pela Positronic Tech está descrito em nossa <a href="/politica-privacidade" className="text-blue-600 underline">Política de Privacidade</a>, em total conformidade com a Lei Geral de Proteção de Dados (LGPD). Ao utilizar nossos serviços, o usuário também concorda com os termos dessa política.</p>

				<p className="font-bold mt-4">9. Foro e legislação aplicável</p>
				<p>Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca do Rio de Janeiro/RJ para dirimir quaisquer controvérsias, com exclusão de qualquer outro, por mais privilegiado que seja.</p>

				<p className="font-bold mt-4">10. Contato</p>
				<p>Em caso de dúvidas, sugestões ou solicitações relacionadas a estes Termos, entre em contato conosco:</p>

				<p className="mt-8">E-mail: <a href="mailto:suporte@positronictech.com.br">suporte@positronictech.com.br</a></p>

				<p className="mt-8 self-end">Data da última atualização: 12/06/2025</p>
			</Card>
		</div>
	)
}
